/** True, wenn das Projektjahr und das Jahr des Ordner-Datensatzes auseinanderfallen. */
export function projectFolderYearMismatch(project: {
  jahr?: number | null;
  ordner_jahr?: number | null;
  ordner_id?: number | null;
  sordner_id?: number | null;
}): boolean {
  if (project.sordner_id && !project.ordner_id) return false;
  if (project.ordner_jahr == null || project.jahr == null) return false;
  return Number(project.ordner_jahr) !== Number(project.jahr);
}
